enum ProposalStatusEnum {
    IN_PROGRESS = 'IN_PROGRESS',
    ACCEPTED = 'ACCEPTED',
    DECLINED = 'DECLINED'
}

export default ProposalStatusEnum;
